import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPost, adminPut, adminDel } from "@/lib/adminApi";
import { capFirst } from "@/lib/profile";

export default function Pillars() {
  const [pillars, setPillars] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const load = () => adminGet("/pillars").then((d) => setPillars(d.pillars)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!name.trim()) {
      toast("Donnez un nom au pilier.");
      return;
    }
    await adminPost("/pillars", { name: capFirst(name.trim()), description: capFirst(description.trim()), order: pillars.length + 1, active: true }).catch(() => {});
    setName("");
    setDescription("");
    load();
  };

  const toggle = async (p) => {
    await adminPut(`/pillars/${p.id}`, { ...p, active: !p.active }).catch(() => {});
    load();
  };

  const remove = async (p) => {
    await adminDel(`/pillars/${p.id}`).catch(() => {});
    load();
  };

  return (
    <div data-testid="admin-pillars-module">
      <h2 className="rav-admin-h2">Piliers</h2>
      <p className="rav-page-sub rav-admin-note">Les piliers structurent les contenus et la composition des Instants.</p>
      <div className="rav-admin-list">
        {pillars.map((p, i) => (
          <div key={p.id} className="rav-admin-row" data-testid={`pillar-row-${i}`}>
            <span className="rav-admin-row-label">{p.name}{!p.active ? " · masqué" : ""}</span>
            <span className="rav-admin-row-sub">{p.description}</span>
            <span className="rav-admin-row-actions">
              <button type="button" className="rav-text-link" data-testid={`pillar-toggle-${i}`} onClick={() => toggle(p)}>
                {p.active ? "Masquer" : "Afficher"}
              </button>
              <button type="button" className="rav-text-link" data-testid={`pillar-delete-${i}`} onClick={() => remove(p)}>
                Supprimer
              </button>
            </span>
          </div>
        ))}
      </div>
      <div className="rav-admin-form">
        <input className="rav-input" data-testid="pillar-name" placeholder="Nom du pilier" value={name} onChange={(e) => setName(capFirst(e.target.value))} />
        <input className="rav-input" data-testid="pillar-description" placeholder="Description" value={description} onChange={(e) => setDescription(capFirst(e.target.value))} />
        <button type="button" className="rav-secondary-button rav-session-btn rav-admin-create" data-testid="pillar-add" onClick={add}>
          Ajouter un pilier
        </button>
      </div>
    </div>
  );
}
